// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { localize } from 'i18n-calypso'

// Internal Dependencies:
import LoadingSpinner from 'church-theme-library/components/LoadingSpinner/LoadingSpinner'
import PostSectionB from 'church-theme-library/components/PostSections/PostSectionB'

class SermonsLayout extends React.Component {
	componentDidMount() {
		window.scrollTo( 0, 0 )
	}

	renderContent() {
		const {
			type,
			selectedArchive,
			match,
			loadingById,
			showSetA,
			showSetZ,
			postsSetA,
			postsSetZ,

			numberOfSermonSeries,
			showSermonSeriesSetA,
			showSermonSeriesSetZ,
			sermonSeriesSetA,
			sermonSeriesSetZ,

			translate
		} = this.props

		if ( ! showSermonSeriesSetA && ! showSermonSeriesSetZ && ! showSetA && ! showSetZ ) {
			return null
		}

		return (
			<div className="wide-sections">
				{/* Sermon Series */}

				{ showSermonSeriesSetZ && sermonSeriesSetZ &&
					<PostSectionB
						type={ type }
						posts={ sermonSeriesSetZ }
						heading={ translate( 'Sermon series' ) }
					/>
				}

				{/* Single Sermons */}

				{ showSetZ && postsSetZ &&
					<PostSectionB
						type={ type }
						posts={ postsSetZ }
						heading={ translate( 'Sermons' ) }
					/>
				}

				<div className="-layout-bg">
					<img src={ `${siteData.images_url}layouts/PNGMarch2017-159.jpg` } alt="" />
				</div>

				<svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 500 500">
					<defs>
						<clipPath id="svg-layout-bg-clip" clipPathUnits="objectBoundingBox">
							<path d="M0.47940791326531,0.88376853142857 C0.42864807040816,0.95549795142857 0.3579178244898,1 0.27968550408163,1 C0.12521946530612,1 0,0.82651034 0,0.6125 C0,0.47064633714286 0.055015293877551,0.34659547428571 0.13709690102041,0.2790703 C0.15119605510204,0.12175503485714 0.24803319489796,0 0.36539557755102,0 C0.44827044387755,0 0.52091058571429,0.060712032857143 0.56141010204082,0.15178580714286 C0.59426133367347,0.12674508114286 0.63200367244898,0.1125 0.67214742040816,0.1125 C0.79920819387755,0.1125 0.90221130204082,0.25520923571429 0.90221130204082,0.43125 C0.90221130204082,0.45943181571429 0.89957155816327,0.48675941714286 0.89461595816327,0.51278406428571 L0.89461595816327,0.51278406428571 C0.95258663571429,0.55264938571429 0.99243243265306,0.63550269714286 0.99243243265306,0.73125 C0.99243243265306,0.86586940714286 0.91366534897959,0.975 0.81650122857143,0.975 C0.77024686836735,0.975 0.72816159897959,0.95026909428571 0.69675813163265,0.90983054428571 C0.66899289183673,0.93522066142857 0.63572744081633,0.95 0.59997051632653,0.95 C0.55331260408163,0.95 0.51089684897959,0.92483567714286 0.47940791326531,0.88376853142857 Z"></path>
						</clipPath>
					</defs>
				</svg>
			</div>
		)
	}

	render() {
		const { selectedArchive, isLoading, loadingById, match, translate } = this.props
		const slug = match.params.slug
		const catId = `id_${slug}`
		const hasCorrectArchiveData = ( selectedArchive && ( 'sermons' == selectedArchive.type || 'sermons-category' == selectedArchive.type ) )
		let showLoading = ! hasCorrectArchiveData || isLoading || ( loadingById && loadingById[ catId ] )

		return (
			<div>
				<div className="main-inner">
					{ showLoading &&
						<LoadingSpinner />
					||
						this.renderContent()
					}
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		page: state.page.selected,
		selectedArchive: state.page.selectedArchive,
		showSetA: state.page.showSetA,
		showSetZ: state.page.showSetZ,
		postsSetA: state.page.postsSetA,
		postsSetZ: state.page.postsSetZ,

		numberOfSermonSeries: state.page.numberOfSermonSeries,
		showSermonSeriesSetA: state.page.showSermonSeriesSetA,
		showSermonSeriesSetZ: state.page.showSermonSeriesSetZ,
		sermonSeriesSetA: state.page.sermonSeriesSetA,
		sermonSeriesSetZ: state.page.sermonSeriesSetZ,

		isLoading: state.page.isLoading,
		loadingById: state.page.loadingById
	}
}

export default localize(
	connect( mapStateToProps )( SermonsLayout )
)
